import Swal from 'sweetalert2';

export const setSmallScreenStyles = () => {
  const resizeHandler = () => {
    const isSmall = window.innerHeight < 380;
    Swal.getIcon().classList.toggle('swal-is-small', isSmall);
    Swal.getTitle().classList.toggle('swal-is-small', isSmall);
  };
  resizeHandler();
  window.addEventListener('resize', resizeHandler);
};
